export default "__VITE_ASSET__XWKSNNcB__"